import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/couleur-colmar.jpg';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-c2a83712"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["id"];

var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    class: "logo",
    src: _imports_0
  }, null, -1);
});

var _hoisted_3 = [_hoisted_2];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    id: _ctx.id
  }, _hoisted_3, 8, _hoisted_1);
}